import React, { useEffect, useRef, useState } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import './index.scss';

const ScrollComponent = (props) => {
    const scrollRef = useRef(null);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const [canScrollLeft, setCanScrollLeft] = useState(false);

    useEffect(() => {
        checkScrollPosition();
        if (scrollRef.current) {
            scrollRef.current.addEventListener('scroll', checkScrollPosition);
        }
        return () => {
            if (scrollRef.current) {
                scrollRef.current.removeEventListener('scroll', checkScrollPosition);
            }
        };
    }, [props.watch]);

    const handleScrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                top: 0,
                left: 340,
                behavior: 'smooth'
            });
        }
    };

    const handleScrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                top: 0,
                left: -340,
                behavior: 'smooth'
            });
        }
    };

    const checkScrollPosition = () => {
        if (scrollRef.current) {
            const { scrollWidth, clientWidth, scrollLeft } = scrollRef.current;
            setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
            setCanScrollLeft(scrollLeft > 0);
        }
    };

    return (
        <div className="scroll-container">
            {canScrollLeft && (
                <button className="scroll-button left" onClick={handleScrollLeft}>
                    <ChevronLeftIcon />
                </button>
            )}
            <div ref={scrollRef} className="scroll-wrapper">
                {props.children}
            </div>
            {canScrollRight && (
                <button className="scroll-button right" onClick={handleScrollRight}>
                    <ChevronRightIcon />
                </button>
            )}
        </div>
    );
};

export default ScrollComponent;
